import { createRouter, type RouterHistory } from '@tanstack/react-router';
import { routeTree } from '@/app/router/routes';
import { NotFoundPage } from '@/shared/errors';

export function createAppRouter(history?: RouterHistory) {
  return createRouter({
    routeTree,
    history,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultStaleTime: 0,
    defaultGcTime: 0,
    scrollRestoration: true,
    defaultNotFoundComponent: NotFoundPage,
  });
}


export type AppRouter = ReturnType<typeof createAppRouter>;
